// Copyright (c) 2015, Sony Global Education, Inc.
// All rights reserved.

import $ from "jquery";
import * as common from "./common.js";
import * as Constants from "./constants.js";
import "./jquery.slimscroll.mod";
import "fullpage.js";
import "fullpage.js/jquery.fullPage.css";

////////////////////////////////////////////////////////////
//
// Quiz wide variables.

var Q = {};

////////////////////////////////////////////////////////////
//
// Event Handlers.

// function sectionDown(e) {
//   e.preventDefault();
//   $.fn.fullpage.moveSectionDown();
// }

export function didClickAnswer(e) {
  e.preventDefault();

  // On mobile device, we do not use "hover", so have to
  // change color by the code.
  $(e.target).addClass("hover");

  var aid = $(e.target).attr("data-aid");
  console.log(aid);
  var q = aid.split("-");
  var question = +q[0];
  var answer = +q[1];
  var t = answerTime(new Date());
  var ti = indexForSecond(t);
  var r = extractAnswerValue(question, answer, ti);
  storeAnswer(question, answer, ti);
  assignResult(r);

  if (isCorrectAnswer(Constants.CORRECT_ANSWERS, question, answer)) {
    $(e.target).addClass("correct");
  } else {
    $(e.target).addClass("wrong");
  }

  setTimeout(function () {
    $.fn.fullpage.moveSectionDown();
  }, Constants.NEXT_QUESTION_MOVE_WAIT);
}

function hoverAnswer() {
  $(this).toggleClass("hover");
}

function leaveFromSection(index, nextIndex) {
  // Indigo comment: skip SiteAnalysis
  // For Google Analytics.
  // var q = Constants.QUIZ_PATH + nextIndex;
  // SiteAnalysis.send_pageview(q);

  Q.sectionStartDate = new Date();

  updateNavigation(nextIndex - 1);
  if (
    index === Constants.LAST_QUESTION_INDEX &&
    nextIndex === Constants.CALC_INDEX
  ) {
    calcPageHook();
  }
}

// // based on: http://stackoverflow.com/a/20293441
function hasTouchEvent() {
  try {
    document.createEvent("TouchEvent");
    return true;
  } catch (e) {
    return false;
  }
}

// ////////////////////////////////////////////////////////////
// //
// // Page hook

function calcPageHook() {
  var lp = Constants.RESULT_PATH;
  var ss = createScoreString(Q.scoreResults);
  var as = createAnswerString(Q.answers);
  var ts = createTypeString(Q.scoreResults);
  var h = createScoredPageURL(lp, ss, as, ts);

  setTimeout(function () {
    window.location.href = h;
  }, Constants.CALCULATING_TIME);
}

// ////////////////////////////////////////////////////////////
// //
// // Private

function initializeQuizVariable() {
  Q.sectionStartDate = new Date();
  Q.scoreResults = [0, 0, 0, 0, 0];
  Q.answers = [];
}

function indexForSecond(s) {
  var l = Constants.ANSWER_SECONDS.length;
  var r = l - 1;
  for (var i = 0; i < l; i++) {
    if (s < Constants.ANSWER_SECONDS[i]) {
      r = i;
      break;
    }
  }
  return r;
}

function extractAnswerValue(question, answer, timeIndex) {
  return Constants.QUESTIONS[question][answer][timeIndex];
}

function storeAnswer(question, answer, timeIndex) {
  var s = "" + question + answer + timeIndex;

  // XXX: Try to fill missing answers if accidently some answers are skipped.
  for (var i = Q.answers.length; i < question; i++) {
    Q.answers.push(i + "00");
  }

  Q.answers.push(s);
}

function assignResult(r) {
  for (var i = 0, len = r.length; i < len; i++) {
    Q.scoreResults[i] += r[i];
    if (Q.scoreResults[i] < 0) {
      Q.scoreResults[i] = 0;
    }
  }
}

function answerTime(currentTime) {
  if (!Q.sectionStartDate) {
    return Constants.INVALID_ANSWER_TIME;
  }
  var t =
    currentTime - Q.sectionStartDate - Constants.SECTION_START_MARGIN_TIME;

  return Math.max(0, t);
}

function updateNavigation(activeIndex) {
  $($("#progressbar li")[activeIndex - 1])
    .removeClass("active")
    .addClass("done")
    .text("");
  $($("#progressbar li")[activeIndex])
    .addClass("active")
    .text(activeIndex + 1);
}

function createScoredPageURL(path, score_string, answer_string, type_string) {
  var c = "?";
  var h = path + '/';
  if (/\?/.test(h)) {
    c = "&";
  }
  h += c + "d=" + score_string;
  h += "&a=" + answer_string;
  h += "&t=" + type_string;
  h += "&v=" + Constants.MMFORMATVERSION;

  return h;
}

function createScoreString(scores) {
  var r = "";
  var l = scores.length;
  var x;
  for (var i = 0; i < l; i++) {
    x = scores[i] < 256 ? scores[i] : 255;
    r += ("0" + x.toString(16)).slice(-2);
  }

  if (r.length !== 10) {
    r = "0000000000";
  }

  return r.toLowerCase();
}

function createAnswerString(answers) {
  var l = answers.length;
  var s = "";

  for (var i = 0; i < l; i++) {
    s += answers[i];
  }

  return s;
}

function createTypeString(score) {
  var tnum = common.calcCharacterType(score);
  var s = Constants.RESULTS[tnum].type_short_string;

  return s;
}

function isCorrectAnswer(correct_answers, question, answer) {
  var a = correct_answers[question];
  if (a === -1) {
    return true;
  }

  return a === answer;
}

// ////////////////////////////////////////////////////////////
// //
// // For test support.

// function getQuizVariable() {
//   return Q;
// }

// function setQuizVariable(q) {
//   return Q = q;
// }

////////////////////////////////////////////////////////////
//
// Initializer

export function quiz_main() {
  // If you'd like to hide contents during loading, comment
  // out this line.
  $("#fullpage").css("visibility", "visible");

  common.setupBasicPageComponents({ noMenu: true, noFooter: true });

  $("button.answer").click(didClickAnswer);
  // Should not use CSS hover.  Bootstap button + Mobile
  // device cannot handle hover-leave state.
  if (hasTouchEvent()) {
    $("button.answer").on("touchstart", function () {
      $(this).addClass("hover");
    });

    $("button.answer").on("touchend", function () {
      $(this).removeClass("hover");
    });
  } else {
    $("button.answer").hover(hoverAnswer);
  }

  var sc = ["#ffffff", "#ffffff", "#ffffff", "#ffffff", "#ffffff", "#ffffff"];

  $("#fullpage").fullpage({
    paddingBottom: "120px",
    keyboardScrolling: false,
    onLeave: leaveFromSection,
    recordHistory: false,
    sectionsColor: sc,
    scrollOverflow: true,
    verticalCentered: false,
    afterRender: function () {
      $.fn.fullpage.setAllowScrolling(false);
      $("#fullpage").show();
      $("#fullpage").css("visibility", "visible");

      // Indigo comment: skip SiteAnalysis
      // For Google Analytics.
      // SiteAnalysis.send_pageview(QUIZ_PATH + '1');
    },
  });

  initializeQuizVariable();
}

// EOF
